module.exports = __webpack_public_path__ + "img/83.d62a3d99.png";